(function () {
  var root = document.querySelector('.pp-landing');
  if (!root) return;

  var revealItems = root.querySelectorAll('[data-pp-reveal], .pp-hero, .pp-hero__copy, .pp-hero__visual, .pp-section, .pp-editorial, .pp-editorial__copy, .pp-editorial__visual, .pp-before-after, .pp-before-after__copy, .pp-before-after__visual, .pp-final, .pp-benefit, .pp-step, .pp-ingredient, .pp-review, .pp-faq');
  revealItems.forEach(function (item) {
    if (item.hasAttribute('data-pp-reveal')) return;
    item.setAttribute('data-pp-reveal', item.classList.contains('pp-hero__visual') || item.classList.contains('pp-editorial__visual') || item.classList.contains('pp-before-after__visual') ? 'fade' : 'up');
  });
  if (revealItems.length) {
    root.classList.add('pp-motion-ready');

    revealItems.forEach(function (item, index) {
      item.style.setProperty('--pp-reveal-delay', Math.min(index * 55, 220) + 'ms');
    });

    if (!('IntersectionObserver' in window)) {
      revealItems.forEach(function (item) { item.classList.add('is-visible'); });
    } else {
      var revealObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -7% 0px' });

      revealItems.forEach(function (item) { revealObserver.observe(item); });
    }
  }

})();
